import { JurisdictionStatus } from "~/types/vaspid";

// eslint-disable-next-line no-shadow
export enum OnboardingStatus {
  ACTIVE_COMPANY = "ACTIVE_COMPANY",
  COMPLETE_TRAINING = "COMPLETE_TRAINING",
  TEST_AND_ANALYSE = "TEST_AND_ANALYSE",
  COMPLETE_INTEGRATION = "COMPLETE_INTEGRATION",
  GO_LIVE = "GO_LIVE",
}

// eslint-disable-next-line no-shadow
export enum CompliancePhases {
  SPARK = "SPARK",
  AMPLIFY = "AMPLIFY",
  FOUNDATION = "FOUNDATION",
  ELEVATE = "ELEVATE",
}

// eslint-disable-next-line no-shadow
export enum VaspDueDiligenceReviewStatus {
  TRUSTED = "TRUSTED",
  BLOCKED = "BLOCKED",
  MANUAL = "MANUAL",
}

export const JurisdictionStatusReadable: { [key in JurisdictionStatus]: string } = {
  inForce: "In Force",
  limitedScope: "Limited Scope",
  gracePeriodOngoing: "Grace Period Ongoing",
  plansAnnounced: "Plans Announced",
  notAvailable: "Not Available",
};
